import React from 'react';
import { connect } from 'react-redux';

import CreditCashPoolFooter from './CreditCashPoolFooter/CreditCashPoolFooter';
import Button from '../../UI/Button/Button';

const creditCashPool = (props) => {

    const totalBalance = parseInt(props.cashBalance, 10);
    const totalPrice = props.totalPrice;
    const leftBalance = totalBalance - totalPrice;

    return (
        <React.Fragment>
            <div className={`u-borderBottomNormal u-flex u-height60`}>
                <div className={`f-1 u-textAlignLeft u-borderRightNormal u-relative`}>
                    <div className={`mb-2`}>
                        <p className={`u-fontSize13 u-textColorLight u-fontWeightRegular u-lineHeight1`}>Current balance</p>
                    </div>
                    <span className={`u-fontSize16 u-textColorDark u-fontWeightMedium u-lineHeight1`}>&#8377;{totalBalance.toLocaleString()}</span>
                    <div className={`u-absolute u-backgroundColorPrimary u-width20 u-height20 u-borderRadius50 u-flex justify-content-center align-items-center u-top50Percent u-rightNegative10 u-transformYNegative50Percent`}>
                        <span className={`u-lineHeight1 u-fontWeightMedium u-textColorWhite`}>-</span>
                    </div>
                </div>
                <div className={`f-1 u-textAlignCenter u-borderRightNormal u-relative`}>
                    <div className={`mb-2`}>
                        <p className={`u-fontSize13 u-textColorLight u-fontWeightRegular u-lineHeight1`}>Payable amount</p>
                    </div>
                    <span className={`u-fontSize16 u-textColorDark u-fontWeightMedium u-lineHeight1`}>&#8377;{totalPrice.toLocaleString()}</span>
                    <div className={`u-absolute u-backgroundColorPrimary u-width20 u-height20 u-borderRadius50 u-flex justify-content-center align-items-center u-top50Percent u-rightNegative10 u-transformYNegative50Percent`}>
                        <span className={`u-lineHeight1 u-fontWeightMedium u-textColorWhite`}>=</span>
                    </div>
                </div>
                <div className={`f-1 u-textAlignRight`}>
                    <div className={`mb-2`}>
                        <p className={`u-fontSize13 u-textColorLight u-fontWeightRegular u-lineHeight1`}>Amount after payment</p>
                    </div>
                    <span className={`u-fontSize16 u-textColorDark u-fontWeightMedium u-lineHeight1`}>&#8377;{leftBalance.toLocaleString()}</span>
                </div>
            </div>
            <div className={`u-flex justify-content-between align-items-center mt-auto phone-f-column`}>
                <div className={`u-phoneWidth100Percent phone-mb-4`}>
                    <CreditCashPoolFooter/>
                </div>
                <div className={`u-phone-width100Percent`}> 
                    <Button disabled={totalBalance < totalPrice} onClick={props.clicked} theme='Primary' type='Pay'>Pay Now</Button>
                </div>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        cashBalance: state.auth.userBalance.cashPool,
        totalPrice: state.payments.bookingDetails.fareBreakup['Total Flight Price']
    }
}

export default connect(mapStateToProps)(creditCashPool);


// WEBPACK FOOTER //
// ./src/components/Payment/CreditCashPool/CreditCashPool.js